<div class="bill">
    <h4 class="label_lg_bold">الفاتورة</h4>

    <ng-container *ngIf="billInfo?.cost || billInfo?.cost == '0'">
        <app-order-details [info]="{label: title, value: billInfo?.cost?.toLocaleString() + ' ريال '}" />
    </ng-container>

    <ng-container *ngIf="billInfo?.tax || billInfo?.tax == '0'">
        <app-order-details [info]="{label: 'قيمة الضريبة المضافة', value: billInfo?.tax?.toLocaleString() + ' ريال '}"/>
    </ng-container>
    
    <ng-container *ngIf="billInfo?.total || billInfo?.total == '0'">
        <app-order-details [info]="{label: 'المجموع', value: billInfo?.total?.toLocaleString() + ' ريال '}"/>
    </ng-container>

</div>